import { Button } from "primereact/button"

export default function TriStateButtons({ value, onChange, scaled = false }) {

    value = value === null || value === undefined ? null : value ? true : false

    const selected = value === null ? 3 : value ? 1 : 2

    const severityYes = selected === 1 ? 'secondary' : ''
    const severityNo = selected === 2 ? 'secondary' : ''
    const severityIgnore = selected === 3 ? '' : ''


    const onClick = (e, newSelected) => {
        e.preventDefault()
        const bolValue = newSelected === 1 ? true : newSelected === 2 ? false : null
        onChange(bolValue)
    }

    const buttonStyle = { maxWidth: scaled ? '' : '4rem' }

    return (
        <div className="flex gap-1 w-full">
            <Button className="text-xs" outlined={selected !== 1} label="Sim" severity={severityYes} style={buttonStyle} onClick={(e) => onClick(e, 1)} rounded />
            <Button className="text-xs" outlined={selected !== 2} label="Não" severity={severityNo} style={buttonStyle} onClick={(e) => onClick(e, 2)} rounded />
            <Button className="text-xs" outlined={true} label="Ignorar" severity={severityIgnore} style={buttonStyle} onClick={(e) => onClick(e, 3)} rounded />
        </div>
    )
}